// Soccer Nations card game data with rankings
export const SOCCER_CARDS = [
  { id: 1, name: "Spain", rank: 1 ,
    image: "/images/soccer/soccer_1.jpg"
  },
  { id: 2, name: "Argentina", rank: 2 ,
    image: "/images/soccer/soccer_2.jpg"
  },
  { id: 3, name: "France", rank: 3 ,
    "image": "/images/soccer/soccer_31.jpg"
  , image: "/images/soccer/soccer_3.jpg"},
  { id: 4, name: "England", rank: 4 ,
    "image": "/images/soccer/soccer_32.jpg"
  , image: "/images/soccer/soccer_4.jpg"},
  { id: 5, name: "Portugal", rank: 5 ,
    image: "/images/soccer/soccer_5.jpg"
  },
  { id: 6, name: "Netherlands", rank: 6 ,
    image: "/images/soccer/soccer_6.jpg"
  },
  { id: 7, name: "Brazil", rank: 7 ,
    "image": "/images/soccer/soccer_33.jpg"
  , image: "/images/soccer/soccer_7.jpg"},
  { id: 8, name: "Belgium", rank: 8 ,
    image: "/images/soccer/soccer_8.jpg"
  },
  { id: 9, name: "Italy", rank: 9 ,
    "image": "/images/soccer/soccer_34.jpg"
  , image: "/images/soccer/soccer_9.jpg"},
  { id: 10, name: "Germany", rank: 10 ,
    "image": "/images/soccer/soccer_35.jpg"
  , image: "/images/soccer/soccer_10.jpg"},
  { id: 11, name: "Croatia", rank: 11 ,
    image: "/images/soccer/soccer_11.jpg"
  },
  { id: 12, name: "Morocco", rank: 12 ,
    image: "/images/soccer/soccer_12.jpg"
  },
  { id: 13, name: "Columbia", rank: 13 ,
    "image": "/images/soccer/soccer_36.jpg"
  , image: "/images/soccer/soccer_13.jpg"},
  { id: 14, name: "Mexico", rank: 14 ,
    "image": "/images/soccer/soccer_37.jpg"
  , image: "/images/soccer/soccer_14.jpg"},
  { id: 15, name: "Uruguay", rank: 15 ,
    image: "/images/soccer/soccer_15.jpg"
  },
  { id: 16, name: "United States", rank: 16 ,
    "image": "/images/soccer/soccer_38.jpg"
  , image: "/images/soccer/soccer_16.jpg"},
  { id: 17, name: "Switzerland", rank: 17 ,
    image: "/images/soccer/soccer_17.jpg"
  },
  { id: 18, name: "Senegal", rank: 18 ,
    image: "/images/soccer/soccer_18.jpg"
  },
  { id: 19, name: "Japan", rank: 19 ,
    "image": "/images/soccer/soccer_39.jpg"
  , image: "/images/soccer/soccer_19.jpg"},
  { id: 20, name: "Denmark", rank: 20 ,
    image: "/images/soccer/soccer_20.jpg"
  },
  { id: 21, name: "Iran", rank: 21 ,
    "image": "/images/soccer/soccer_40.jpg"
  , image: "/images/soccer/soccer_21.jpg"},
  { id: 22, name: "South Korea", rank: 22 ,
    "image": "/images/soccer/soccer_41.jpg"
  , image: "/images/soccer/soccer_22.jpg"},
  { id: 23, name: "Ecuador", rank: 23 ,
    image: "/images/soccer/soccer_23.jpg"
  },
  { id: 24, name: "Austria", rank: 24 ,
    image: "/images/soccer/soccer_24.jpg"
  },
  { id: 25, name: "Australia", rank: 25 ,
    image: "/images/soccer/soccer_25.jpg"
  },
  { id: 26, name: "Turkey", rank: 26 ,
    "image": "/images/soccer/soccer_42.jpg"
  , image: "/images/soccer/soccer_26.jpg"},
  { id: 27, name: "Ukraine", rank: 27 ,
    image: "/images/soccer/soccer_27.jpg"
  },
  { id: 28, name: "Canada", rank: 28 ,
    image: "/images/soccer/soccer_28.jpg"
  },
  { id: 29, name: "Norway", rank: 29 ,
    image: "/images/soccer/soccer_29.jpg"
  },
  { id: 30, name: "Russia", rank: 30 ,
    "image": "/images/soccer/soccer_43.jpg"
  , image: "/images/soccer/soccer_30.jpg"}
];
